<template>
  <div>
    <NavBar/>
    <van-row type="flex" justify="center" class="house_list" :style="{height:pageHeight+'px'}">
      <van-col :span="24">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="card" v-for="item in list" :key="item" @click="skipDetail(item)">
            <van-row class="house_site"><van-col span="24">{{item.a}}</van-col></van-row>
            <van-row class="house_no"><van-col span="24">房屋交易业务编号：{{item.b}}</van-col></van-row>
            <van-row>
              <van-col span="8" class="content_left">
                <van-col span="24" class="house_area">{{item.f}}</van-col>
                <van-col span="24">建筑面积（㎡）</van-col>
              </van-col>
              <van-col span="8" class="content_left">
                <van-col span="24" class="house_money">{{item.e}}</van-col>
                <van-col span="24">交存状态</van-col>
              </van-col>
              <van-col span="8" class="content_left">
                <van-col span="24" class="house_money">{{item.d}}</van-col>
                <van-col span="24">应交金额（元）</van-col>
              </van-col>
            </van-row>
          </div>
        </van-list>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="house_bottom">
      <van-col :span="22" v-if="bottomShow">
        <van-row type="flex" justify="space-around">
          <van-col class="house_icon" :span="2"><van-icon name="bars" size="30" color="#ff976a"/></van-col>
          <van-col class="house_text" offset="1" :span="21">查询结果显示您存在7条房屋记录，请核对并点击下一步，系统将为您进行数据校验。</van-col>
        </van-row>
        <van-row type="flex" justify="center">
          <van-col :span="24" class="house_checkbox fixesdCheck">
            <van-checkbox style="width:50px" v-model="checked">
            </van-checkbox>
            <span>
              我同意威海市南海维修资金使用我所提交的信息用于房屋数据校验。
              <span style="color:#428bca">《隐私协议》</span>
            </span>
          </van-col>
        </van-row>
        <van-row type="flex" justify="center">
          <van-col :span="24" class="house_button">
            <van-button type="danger" size="normal" :disabled="!checked" @click="houseTest">下一步</van-button>
          </van-col>
        </van-row>
      </van-col>
      <van-col :span="22" v-else class="house_button">
        <van-button type="danger" size="normal">重新发起校验</van-button>
      </van-col>
    </van-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading:false,
      finished: false,
      list:[
        {a:"威海市南山区XX路11号XXX小区A区11幢2楼201",b:"100000000000011",c:"高层（100）",d:"20000.00",e:"未交存",f:"200.00"},
        {a:"威海市南山区XX路11号XXX小区A区11幢2楼201",b:"100000000000011",c:"高层（100）",d:"20000.00",e:"未交存",f:"200.00"},
        {a:"威海市南山区XX路11号XXX小区A区11幢2楼201",b:"100000000000011",c:"高层（100）",d:"20000.00",e:"未交存",f:"200.00"},
        {a:"威海市南山区XX路11号XXX小区A区11幢2楼201",b:"100000000000011",c:"高层（100）",d:"20000.00",e:"未交存",f:"200.00"},
        {a:"威海市南山区XX路11号XXX小区A区11幢2楼201",b:"100000000000011",c:"高层（100）",d:"20000.00",e:"未交存",f:"200.00"},
        {a:"威海市南山区XX路11号XXX小区A区11幢2楼201",b:"100000000000011",c:"高层（100）",d:"20000.00",e:"未交存",f:"200.00"},
        {a:"威海市南山区XX路11号XXX小区A区11幢2楼201",b:"100000000000011",c:"高层（100）",d:"20000.00",e:"未交存",f:"200.00"},
        {a:"威海市南山区XX路11号XXX小区A区11幢2楼201",b:"100000000000011",c:"高层（100）",d:"20000.00",e:"未交存",f:"200.00"},
        {a:"威海市南山区XX路11号XXX小区A区11幢2楼201",b:"100000000000011",c:"高层（100）",d:"20000.00",e:"未交存",f:"200.00"},
      ],
      shows:false,
      busiNo:"",
      regionId:"",
      subRegion:"",
      buildNo:"",
      cellNo:"",
      buildNum:"",
      houseNo:"",
      showPicker:false,
      checked:false,
      pageHeight:0,
      bottomShow:true,
      columns:[{ text: '杭州', disabled: false, id:"343344"},]
    };
  },
  methods:{
    onLoad(){

    },
    // 下一步（系统历史数据校验）
    houseTest(){
      this.bottomShow = false;
      this.pageHeight = document.documentElement.clientHeight-40;
    },
    skipDetail(item){
      let data = JSON.stringify(item)
      this.$router.push({
        path:"/HouseDetails",
        query:{
          houseInfo:data
        }
      })
    }
  },
  mounted() {
  },
  created() {
    this.pageHeight = document.documentElement.clientHeight-140;
    console.log(this.pageHeight);
  },
}
</script>
<style>
.IncludeLists {
  margin-top: 46px;
}
.house_button{
  margin: 10px;
}
.house_button .van-button,.content_button .van-button{
  padding: 3px 15px;
  width: 100%;
}
.house_list .card{
  padding: 5px 10px;
  font-size: 12px;
  margin-top: 46px;
}
.house_list .van-col{
  margin-top:10px;
  margin-bottom:10px;
}
.house_list{
  overflow: auto;
}
.huose_wrapper{
  height: 100%;
  overflow: auto;
}
.house_site,.house_area,.house_money{
  font-size: 14px;
  font-weight: bold;
}
.content_left,.content_right{
  margin: 0 !important;
  text-align: center;
}
.house_text,.house_checkbox{
  font-size: 13px;
  line-height: 18px;
}
.house_bottom{
  position:absolute;
  bottom:0;
  left:0;
  background-color: #ffffffc5;
  padding-top: 10px;
  width: 100%;
}
.fixesdCheck{
  display: flex;
  align-items: center;
}
</style>